/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Amateur_4_HeadingInputs */

const en_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Beyond Golf`)
};

const es_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación más allá del golf`)
};

const de_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendung über Golf hinaus`)
};

const zh_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高尔夫之外的应用`)
};

const ar_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التطبيق خارج الغولف`)
};

const fr_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application au-delà du golf`)
};

const vi_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ứng dụng ngoài golf`)
};

const sw_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matumizi nje ya gofu`)
};

const th_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การนำไปใช้นอกเหนือจากกอล์ฟ`)
};

const bs_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primjena van golfa`)
};

const ja_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフを超えてアプリケーション`)
};

const ko_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프를 넘어`)
};

const pt_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicação Além do Golf`)
};

const it_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicazione Oltre il golf`)
};

const sv_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökan bortom Golf`)
};

const nl_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toepassing voorbij Golf`)
};

const da_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anvendelse ud over golf`)
};

const nb_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søknad Beyond Golf`)
};

const fi_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovellus Golfin ulkopuolella`)
};

const pl_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastosowanie Poza Golfem`)
};

const ru_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За пределами гольфа`)
};

const tr_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfün Ötesinde Uygulama`)
};

const hi_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवेदन परे गोल्फ`)
};

const id_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerapan di Luar Golf`)
};

const ms_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerapan di Luar Golf`)
};

const cs_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikace předvést mimo Golf`)
};

const el_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εφαρμογή πέρα από το γκολφ`)
};

const he_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יישום מעבר לגולף`)
};

const af_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toepassing verby gholf`)
};

const hu_method_content_step_06_detail_amateur_4_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alkalmazás a golfon túl`)
};

/**
* | output |
* | --- |
* | "Application Beyond Golf" |
*
* @param {Method_Content_Step_06_Detail_Amateur_4_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_amateur_4_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Amateur_4_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Amateur_4_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_amateur_4_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_amateur_4_heading(inputs)
	return en_method_content_step_06_detail_amateur_4_heading(inputs)
});